import type { ReactNode } from "react";
import { cx } from "./cx";

/** A labelled field (`.field`): the label, the control, then a hint or an error the control is described by. */
export function Field({ label, htmlFor, hint, error, className, children }: {
  label: ReactNode;
  /** The control's id, so a click on the label focuses it. */
  htmlFor?: string;
  hint?: ReactNode;
  error?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cx("field", className)}>
      <label htmlFor={htmlFor}>{label}</label>
      {children}
      {error ? (
        <div className="hint fld-err" role="alert" id={htmlFor ? `${htmlFor}-err` : undefined}>
          {error}
        </div>
      ) : hint ? (
        <div className="hint" id={htmlFor ? `${htmlFor}-hint` : undefined}>
          {hint}
        </div>
      ) : null}
    </div>
  );
}
